import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { authActions, getUser, isUserLoggedIn } from "../../reduxSlices/auth";
import { routes } from "../../routes";

const NavBarUserLink = styled(Link)({
  textDecoration: "none",
});

export default function NavBarUser() {
  const dispatch = useAppDispatch();
  const loggedIn = useAppSelector(isUserLoggedIn);
  const user = useAppSelector(getUser);
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      {loggedIn && user ? (
        <>
          {user.firstName ? user.firstName : smallScreen ? user.email.split("@")[0] : user.email}
          {" |"}
          {
            <Button
              color="secondary"
              variant="text"
              onClick={() => {
                dispatch(authActions.logoutUser());
              }}
            >
              Logout
            </Button>
          }
        </>
      ) : (
        <NavBarUserLink to={routes.login.path}>
          <Button color="secondary" variant="text">
            Login
          </Button>
        </NavBarUserLink>
      )}
    </>
  );
}
